import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

const BareMulticastIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 18 18' {...props}>
    <g className='graph-icon'>
      <path
        d='M15.5 17c.827 0 1.5-.673 1.5-1.5s-.673-1.5-1.5-1.5-1.5.673-1.5 1.5.673 1.5 1.5 1.5zm0-6c.827 0 1.5-.673 1.5-1.5S16.327 8 15.5 8 14 8.673 14 9.5s.673 1.5 1.5 1.5zm-13 0c.827 0 1.5-.673 1.5-1.5a1.501 1.501 0 00-3 0c0 .827.673 1.5 1.5 1.5zm13-6c.827 0 1.5-.673 1.5-1.5S16.327 2 15.5 2 14 2.673 14 3.5 14.673 5 15.5 5zm0 13a2.5 2.5 0 11.001-5 2.5 2.5 0 010 5zm0-6a2.5 2.5 0 11.001-5.001 2.5 2.5 0 010 5.001zm-13 0a2.5 2.5 0 110-5.001A2.5 2.5 0 012.5 12zm13-6a2.5 2.5 0 110-5 2.5 2.5 0 010 5z'
        fill='#323232'
      />
      <path
        d='M7.992 16H2v-5h1v4h4.991v-2.007l3.01 2.507L7.994 18l-.003-2zm0-6H4.45V9h3.542V6.992L11 9.5 7.995 12l-.003-2zM2 8V3h5.991V.992l3.01 2.508L7.994 6V4H3v4H2z'
        fill='#323232'
      />
    </g>
  </SvgWrapper>
);
export const MulticastIcon = memo(BareMulticastIcon);
